import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useGlobalSettings } from "../context/GlobalSettingsContext";

function SetupProfileRoute() {
  const firstLoginState = useSelector((state) => state.firstLoginState.value);
  const setupAccountState = useSelector(
    (state) => state.setupAccountState.value
  );
  const { defaultLandingPage } = useGlobalSettings();
  if (!firstLoginState) {
    if (setupAccountState) {
      return <Navigate to={"/setup-account"} replace />;
    } else {
      return <Navigate to={defaultLandingPage || "/my-plans"} replace />;
    }
  } else {
    return <Outlet />;
  }
}

export default SetupProfileRoute;
